// theme/components/accordion.js
export default {
    baseStyle: {
        border: 'none',
        button: {
            paddingLeft: 0,
            paddingRight: 0,
            _hover: {
                background: 'none'
            }
        },
        panel: {
            paddingTop: 0,
            paddingBottom: 0
        }
    },
    variants: {
        filter: {
            container: {
                paddingLeft: {base: '16px', lg: '32px'},
                paddingRight: {base: '16px', lg: '32px'},
                paddingTop: '20px',
                paddingBottom: '20px'
            },
            button: {
                padding: 0,
                fontWeight: 500,
                border: 'none'
            },
            panel: {
                paddingTop: '20px',
                paddingRight: 0,
                paddingBottom: '20px',
                paddingLeft: 0
            }
        },
        sidebar: {
            container: {
                padding: '12px 16px'
            },
            button: {
                border: 'none'
            }
        }
    }
}
